import React, { Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './pending-teacher-bar.styles.js'
import { withMe } from 'pobble-components/dist/pobble-user'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const PendingTeacherBar = ({ classes, className, me }) => {
  if (
    me &&
    me.account &&
    me.account.pending_teacher_type &&
    (me.account.pending_teacher_type.school ||
      me.account.pending_teacher_type.description)
  ) {
    return (
      <p className={classNames(classes.pendingTeacherBar, className)}>
        We’re just verifying your school. We’ll email you once this is complete.
      </p>
    )
  } else {
    return <Fragment />
  }
}

PendingTeacherBar.propTypes = {
  /** Additional className if you want to restyle component */
  className: PropTypes.string
}

export default withMe(injectSheet(styles)(PendingTeacherBar))
